export default __webpack_public_path__ + "static/media/kitchenTrolly.24427aa6.jpg";